import { Navigate, createFileRoute } from '@tanstack/react-router';

import { DocumentExportPage } from '@/components/document-export/DocumentExportPage';
import { isFeatureEnabled } from '@/lib/featureFlags';

const DocumentExportRoute = () => {
  if (!isFeatureEnabled('DOCUMENT_EXPORT')) {
    return <Navigate to='/hello' replace />;
  }
  return <DocumentExportPage />;
};

export const Route = createFileRoute('/_authenticated/document-export')({
  component: DocumentExportRoute,
});
